import {ApiClient} from "../../clients/ApiClient";

export const api = new ApiClient();